import styled from "styled-components"

const Title = styled.h2`
    color: ${(props) => props.theme.c_color_gradients.c_dark};
    &::after {
      background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
}
`

const Description = styled.div`
    color: ${(props) => props.theme.c_color_gradients.c_dark};
    font-weight: bold;
}
`

export { Title, Description }
